import featuredApps from './featuredApps';
import featuredProducts from './featuredProducts';
import { settings } from './setup';

export default {
  featuredApps,
  featuredProducts,
  settings,
};
